import React from 'react'
import { Section } from "../../ui"
import JoinCommunityPNG from '../../../assets/images/joinCommunity.png'

import './joinCommunity.scss'
const openLink = (e) => {
    e.preventDefault();
    window.open("https://discord.gg/7ycuZFGz", '_blank');
}

const JoinCommunitySection = () => {

    return (
        <Section>
            <div className="joinCommunity-wrapper">
                <img src={JoinCommunityPNG}/>
                <div className="content_container">
                    <h2 className="title">...and join the community</h2>
                    <p className="description">
                        Our NFTs double as membership tokens to our community. As community member you'll be the first to learn about new releases and to be able to feedback on future production projects. On top, you will be part of an exclusive group of Web3 Entertainment enthusiast to drive the future of Entertainment. Stay tuned while we release future membership features.
                    </p>
                    <button onClick={openLink} className="glow-on-hover">JOIN HERE</button>

                </div>
            </div>
        </Section>
    )
}

export default JoinCommunitySection
